export const FILTER_TYPES = {
  name: 'name',
  phone: 'phone',
  email: 'email',
  orderNumber: 'id',
  orderCode: 'externalId',
  location: 'location',
};
